<div mat-dialog-title>
  <h1 id="restore-deleted-dialog">{{ getDialogTitle() | translate }}</h1>
  <cl-btn
    icon="close"
    [label]="'close dialog' | translate"
    buttonStyle="alert small"
    (click)="dialogRef.close(true)" />
</div>

<div mat-dialog-content>
  @if (loading$ | async) {
    <div class="users__loading">
      <mat-progress-spinner mode="indeterminate" />
    </div>
  }

  <div>
    <div class="users__searchLabel">{{ getSearchLabel() | translate }}</div>
    <input
      [(ngModel)]="searchTerm"
      (ngModelChange)="searchTrigger.next()"
      class="users__search"
      id="search"
      placeholder="{{ 'Search by family name...' | translate }}"
      type="text" />
  </div>

  <table
    aria-label="Deleted Users Table"
    class="users__table"
    matSort>
    @if (users.length > 0) {
      <thead>
        <tr class="users__table__header">
          <th
            mat-sort-header="familyName"
            scope="column">
            {{ 'Name' | translate }}
          </th>
          <th
            mat-sort-header="username"
            scope="column">
            {{ 'Username' | translate }}
          </th>
        </tr>
        <tr class="users__table__header">
          <td colspan="3">
            @if (users.length) {
              <div class="teacher-users__select-all">
                <input
                  [checked]="areSelected(users)"
                  class="styled-checkbox"
                  id="select-all-checkbox"
                  type="checkbox" />
                <label
                  (click)="toggleUsers(users, true); $event.preventDefault()"
                  for="select-all-checkbox"
                  id="select-all-label">
                  {{ 'Select All' | translate }}
                </label>
              </div>
            }
          </td>
        </tr>
      </thead>
    }

    <tbody>
      @for (user of users; track user) {
        <tr
          (click)="toggleUser(user); $event.preventDefault()"
          class="users__table__row">
          <td>
            <input
              [checked]="isSelected(user)"
              class="styled-checkbox"
              id="user_checkbox_{{ user.identifier }}"
              type="checkbox" />
            <label for="user_checkbox_{{ user.identifier }}">
              {{ user.familyName }}, {{ user.givenName }}
            </label>
          </td>
          <td>{{ user.userName }}</td>
        </tr>
      }

      @if (users.length === 0 && !(loading$ | async)) {
        <tr>
          <td>There are no deleted users to display.</td>
        </tr>
      }
    </tbody>
  </table>
</div>

<mat-paginator
  [length]="totalCountDeletedUsers$ | async"
  [pageSizeOptions]="[10, 50, 100]"
  showFirstLastButtons />

<div mat-dialog-actions>
  <cl-btn
    (click)="restoreUsers()"
    [buttonStyle]="(loading$ | async) || this.selectedUsers.length === 0 ? 'disabled' : ''"
    [id]="'restore-users-button'">
    {{ 'Restore' | translate }}
  </cl-btn>
</div>
